import React from "react";

const OpenDaysContext = React.createContext();

export { OpenDaysContext };
